function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

$(document).ready(function() {

	var dirRtlFlag = false;
	if ($("html").attr('dir') == 'rtl') {
		dirRtlFlag = true;
	}

	$('.drinks-slider').slick({
		dots: false,
		infinite: true,
		speed: 2000,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 3000,
		rtl: dirRtlFlag,
		responsive: [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 825,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 580,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

    $('.select-2-city').select2({
        rtl: true,
        language: "he",
        placeholder: 'עיר', 
        ajax: {
          url: $('html').attr('data-baseurl') + 'index.php?dir=site&page=orders&op=findcity&v=0.2',
          dataType: 'json',
          processResults: function (data) {
            return {
              results: data.items
            };
          }
        }
      });

      $('.btn-quest').on('click', function (e) {
        e.preventDefault();
        var $button = $(this);
        $.get( $button.attr('href'), function( data ) {
          data = $(data);
          $("#formModal .custom-form").html(data.find(".custom-form"));
          $('#formModal').modal()
        });
        return false;
      });
      $("body").on("submit", "#formModal form", function(e){

        var $form = $("#formModal form")
        $form.find('.btn-form').prop('disabled', true);
        $.ajax({
               type: "POST",
               url: $form.attr("action"),
               data: $form.serialize(), // serializes the form's elements.
               success: function(data)
               {
                   data = $(data);
                   if(data.find(".custom-form").html().length > 20){
                     $("#formModal .custom-form").html(data.find(".custom-form"));
                     $form.find('.btn-form').prop('disabled', false);
                   }
                   else{
                     $("#formModal .custom-form").html(data.find(".header-text"));
                     setTimeout(function() {
                        $('#formModal').modal('hide');
                      }, 2000);
                   }
               }
             });
        e.preventDefault();
        return false;
      });


      $(".product-radio").change(function(){
        //{{childs.0.site_price}} ₪
        $(".update-price-catalog-change").text($(this).data('price') + ' ₪');
      });

     $('#autocomplete').autocomplete({
        width: 'flex',
         lookup: function (query, done) {
             var result;
             $.ajax({
               type: "GET",
               url: 'index.php?dir=site&page=catalog&op=search&q='+query,
               dataType: 'json',
               success: function(data){
                 done(data);
               }
             });
         },
         onSelect: function (suggestion) {
             window.location = suggestion.data;
         }
     });

     $(".check_delivery2").click(function(){
           $(".show-deliviery2").fadeToggle();
       });
})



// ##################################################

function getTimeRemaining(endtime) {
  var t = endtime - Date.parse(new Date());
  var seconds = Math.floor((t / 1000) % 60);
  var minutes = Math.floor((t / 1000 / 60) % 60);
  var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
  var days = Math.floor(t / (1000 * 60 * 60 * 24));
  return {
    'total': t,
    'days': days,
    'hours': hours,
    'minutes': minutes,
    'seconds': seconds
  };
}

function initializeClock(id, endtime) {
  var clock = document.getElementById(id);
  var daysSpan = clock.querySelector('.days');
  var hoursSpan = clock.querySelector('.hours');
  var minutesSpan = clock.querySelector('.minutes');
  var secondsSpan = clock.querySelector('.seconds');

  function updateClock() {
    var t = getTimeRemaining(endtime);

    daysSpan.innerHTML = t.days;
    hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
    minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
    secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);

    if (t.total <= 0) {
      clearInterval(timeinterval);
      $('.wrapper-clockdiv').css('display', 'none');
      location.reload();
      return false;
    }
  }

  updateClock();
  var timeinterval = setInterval(updateClock, 1000);
}


$(function() {

  if ($('#clockdiv').length > 0) {
    var timedate = $('#clockdiv').data('timedate');
    if(timedate) {
      $('.wrapper-clockdiv').fadeIn();
    }

    var countDownDate = new Date(timedate).getTime();
    // var deadline = new Date(Date.parse(new Date()) + 5 * 24 * 60 * 60 * 1000);

    initializeClock('clockdiv', countDownDate); 
  }

  /**
   * Update Price of more items and add/remove images
   */


  $(".update-buy-btn").change(function() {
    var price = 0;

    $(this).closest('.section-recommended-package').find('.recommended-package-list-prod__item_show').last().attr('data-content-css','+');
    
    $(".update-buy-btn").each(function(){
      var em = $(this);
      if(this.checked){
          price += em.data("price");
          $(".recommended-package-list-prod__item[data-item-cs='"+ em.data("item-cs") + "']").fadeIn();
          $(".recommended-package-list-prod__item[data-item-cs='"+ em.data("item-cs") + "']").addClass('recommended-package-list-prod__item_show');
      }
      else{
        $(".recommended-package-list-prod__item[data-item-cs='"+ em.data("item-cs") + "']").fadeOut();
        $(".recommended-package-list-prod__item[data-item-cs='"+ em.data("item-cs") + "']").removeClass('recommended-package-list-prod__item_show');
      }

    });
    $(".update-price-on-buy").text(price.toFixed(0,2));

    $(this).closest('.section-recommended-package').find('.recommended-package-list-prod__item_show').last().attr('data-content-css','');

});
   
});

